import classNames from 'classnames';
import React from 'react';
import { Icon } from 'ui';

const ContentButton = ({
  description,
  icon,
  onClick,
  title,
  value,
  pendoClassName,
}) => (
  <button
    type="button"
    className={classNames('EmptyStateAction u-resetBtn', pendoClassName)}
    onClick={onClick}
    value={value}
  >
    <Icon name={icon} className="EmptyStateAction-icon" />
    <h4 className="EmptyStateAction-title">{title}</h4>
    <p className="EmptyStateAction-description">{description}</p>
  </button>
);

export default ContentButton;
